import { getCustomFields } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/custom-fields';
import { getTimelineExportWidth } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/section-widths';
import { getColorByValue } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/visualisations';
import type { MapStateToProps } from '@atlassian/jira-portfolio-3-portfolio/src/common/types/redux';
import { getColorByLegends } from '@atlassian/jira-portfolio-3-portfolio/src/common/view/color-by-legend/query';
import type { StateProps } from './types';

export const mapStateToProps: MapStateToProps<StateProps> = (state) => ({
	colorByValue: getColorByValue(state),
	customFields: getCustomFields(state),
	colorByLegends: getColorByLegends(state),
	timelineWidth: getTimelineExportWidth(state),
});
